"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockProduct = void 0;
function mockProduct(overrides = {}) {
    return {
        annotations: null,
        best_seller_states: [],
        bin_location: 'ab-cd-01',
        brand: 'mock brand',
        category_name: 'softbaits',
        clarities: [],
        compare_at_price: null,
        created_at: '2022-10-20T21:01:51.682Z',
        hidden: false,
        id: 193825718923457,
        img_url: 'http://example.com/img.jpg',
        in_stock: true,
        inventory_tracked: true,
        inventory: 1,
        mfr_item_number: '1481902841092841287',
        on_sale: false,
        popularity: 50,
        price: '0.99',
        shopify_graphql_id: 'mock shopify_graphql_id',
        shopify_product_handle: 'mock_shopify_handle',
        shopify_product_id: '54103845190841290',
        shopify_product_title: 'mock_shopify_title',
        shopify_options: [
            {
                name: 'SIZE',
                value: '3-1/2"',
            },
            {
                name: 'COLOR',
                value: 'PINK TIGER UV',
            },
        ],
        shopify_variant_id: '19164384067641',
        sku: 'mock sku',
        species: [],
        state_fishing_report_counters: {
            MN: 0,
        },
        styles: [],
        subcat_type_name: 'mock subcat_type_name',
        subcategory_name: 'mock subcategory_name',
        tags: [],
        techniques: [],
        title_short: 'mock title_short',
        title: 'mock title',
        zone_1_fishing_reports_count: 0,
        zone_2_fishing_reports_count: 0,
        zone_3_fishing_reports_count: 0,
        ...overrides,
    };
}
exports.mockProduct = mockProduct;
